module.exports = __webpack_public_path__ + "icon-framework-jasmine.2Bh6y0M1.svg";